/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CouponPriceChangeDetail {
  changed?: boolean;
  couponId?: number;
  couponPriceChangeId?: number;
  couponType?: number;
  dateChange?: Date;
  dateCreated?: Date;
  enabled?: boolean;
  products?: number;
  restrictSubscriptionTypes?: string;
  subscriptionTypeNames?: string;
  userEmail?: string;
  userId?: number;
  userName?: string;
  value?: number;
}
